export default "__VITE_ASSET__WxqqRnWh__"